import React, {ReactElement} from 'react';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';
import {Typography} from '@customink/pigment-react';
import {useGetStoreProductQuery} from '../../api/storesApi';
import {useDomPurify} from '../../hooks';
import Price from '../ProductsListingCard/Price';
import './index.scss';

type Props = {
  storeSlug: string;
  productId: number;
};

const StoreProductDescription: React.FC<Props> = ({
  storeSlug,
  productId
}: Props): ReactElement => {
  const {data: product} = useGetStoreProductQuery({
    urlSlug: storeSlug,
    productId
  });
  const {sanitizer} = useDomPurify();

  return (
    <Stack className="storeProductDescription">
      <Typography
        className="storeProductDescription-nameText"
        variant="h5"
        fontWeight="700">
        {product ? product.name : <Skeleton width={170} />}
      </Typography>
      <Price
        price={product?.price}
        originalPrice={product?.originalPrice}
        className="storeProductDescription-priceText"
      />
      <Typography
        className="storeProductDescription-descriptionText"
        variant="bodyLong2">
        {product ? (
          <span
            dangerouslySetInnerHTML={{
              __html: sanitizer(product.description)
            }}
          />
        ) : (
          <>
            <Skeleton width={450} />
            <Skeleton width={450} />
          </>
        )}
      </Typography>
    </Stack>
  );
};

export default StoreProductDescription;
